import React from "react";
import List from "@mui/material/List";

import routesConfig, {
  RouterConfigData,
} from "../../../../../pages/routesConfig";
import NavVerticalGroup from "./VerticalNavGroup";
import VerticalCollapse from "./VerticalCollapse";
import VerticalItem from "./VerticalItem";
import { useSelector } from "react-redux";
import { AppState } from "redux/store";

const VerticalNav = () => {
  const userData = useSelector<AppState, AppState["userData"]>(
    ({ userData }) => userData
  ).userData;

  return (
    <List
      sx={{
        position: "relative",
        padding: 0,
      }}
      component="div"
    >
      {routesConfig.map((item: RouterConfigData) =>
        (userData?.role !== "admin" && item?.id === "clientManagement") ||
        (userData?.role !== "admin" && item?.id === "gateways") ||
        (userData?.role !== "admin" && item?.id === "error_logs") ||
        (userData?.role !== "admin" && item?.id === "config_charges") ||
        (userData?.role !== "app" && item?.id === "config_user_charges") ||
        (userData?.role === "admin" &&
          item?.id === "subscriptionplan") ? null : (
          <React.Fragment key={item.id}>
            {item.type === "group" && (
              <NavVerticalGroup item={item} level={0} />
            )}

            {item.type === "collapse" && (
              <VerticalCollapse item={item} level={0} />
            )}

            {item.type === "item" && <VerticalItem item={item} level={0} />}
          </React.Fragment>
        )
      )}
    </List>
  );
};

export default VerticalNav;
